import { render, staticRenderFns } from "./PlazosImpagados.vue?vue&type=template&id=e7405d42"
import script from "./PlazosImpagados.vue?vue&type=script&lang=js"
export * from "./PlazosImpagados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports